import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MaterialSelectField from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';

class SelectField extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeSelect: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    variant: PropTypes.bool,

    onChange: PropTypes.func,
  };

  static defaultProps = {
    defaultValue: null,
    disabled: false,
    fullWidth: false,
    label: '',
    name: '',
    nativeSelect: false,
    options: [],
    value: '',
    variant: false,

    onChange: noop,
  };

  state = {
    value: (this.props.defaultValue !== '' && this.props.defaultValue !== null) ?
      this.props.defaultValue : this.props.value,
  };

  render() {
    const {
      classes,
      disabled,
      fullWidth,
      label,
      name,
      nativeSelect,
      onChange,
      options,
      variant,
    } = this.props;
    const isExist = options.find(item => item.value === this.state.value);
    return (
      <div>
        <input
          name={name}
          type="hidden"
          value={this.state.value}
        />
        {
          variant ? (
            <FormControl
              classes={{ ...classes.root }}
              variant={variant ? 'outlined' : 'standard'}
            >
              {variant && label && (
                <InputLabel
                  classes={{ ...classes.label }}
                  htmlFor={`${name}-select`}
                  ref={(ref) => {
                    this.InputLabelRef = ref;
                  }}
                  >
                  {label}
                </InputLabel>
              )}
              <MaterialSelectField
                autoWidth
                classes={{ ...classes.select }}
                disabled={disabled}
                fullWidth={fullWidth}
                input={
                  <OutlinedInput
                    id={`${name}-select`}
                    labelWidth={variant ? 80 : 0}
                    name="age"
                  />
                }
                name={name}
                native={nativeSelect}
                onChange={(event) => {
                  this.setState(
                    { value: event.target.value },
                    onChange(event.target.value),
                  );
                }}
                value={isExist ? this.state.value : ''}
              >
                {
                  options.map(({ label: text, value, disabled }, index) => (
                    nativeSelect ? (
                      <option
                        classes={{ ...classes.item }}
                        disabled={(index === 0 && value === '') || disabled}
                        key={value}
                        value={value}
                      >
                        {text}
                      </option>
                    ) : (
                      <MenuItem
                        classes={{ ...classes.item }}
                        key={value}
                        value={value}
                        disabled={disabled}
                      >
                        {text}
                      </MenuItem>
                    )
                  ))
                }
              </MaterialSelectField>
            </FormControl>
          ) : (
            <FormControl
              classes={{ ...classes.root }}
              variant={variant ? 'outlined' : 'standard'}
            >
              {label &&
                <InputLabel
                  classes={{ ...classes.label }}
                  htmlFor={`${name}-select`}
                >
                  {label}
                </InputLabel>
              }
              <MaterialSelectField
                autoWidth
                classes={{ ...classes.select }}
                disabled={disabled}
                fullWidth={fullWidth}
                name={name}
                native={nativeSelect}
                onChange={(event) => {
                  this.setState({ value: event.target.value }, onChange(event.target.value));
                }}
                value={isExist ? this.state.value : ''}
              >
                {
                  options.map(({ label: text, value, disabled }, index) => (
                    nativeSelect ? (
                      <option
                        classes={{ ...classes.item }}
                        disabled={(index === 0 && value === '') || disabled}
                        key={value}
                        value={value}
                      >
                        {text}
                      </option>
                    ) : (
                      <MenuItem
                        classes={{ ...classes.item }}
                        key={value}
                        value={value}
                        disabled={disabled}
                      >
                        {text}
                      </MenuItem>
                    )
                  ))
                }
              </MaterialSelectField>
            </FormControl>
          )
        }
      </div>
    );
  }
}

export default SelectField;
